import { NavLink } from "react-router-dom";
import React from "react";
import useDynamicNav from "../../hooks/useDynamicNav";

const FooterNav = () => {
  const items = useDynamicNav();

  return (
    <nav>
      <ul>
        {items.map((item, key) =>
          item.dropdown ? (
            item.dropdown.map((dropdownItem, dropdownKey) => (
              <li key={dropdownKey}>
                <NavLink
                  to={dropdownItem.link || ""}
                  className="inline-block w-full py-3 text-xs text-gray-400 uppercase transition duration-300 border-b hover:border-black hover:text-black"
                >
                  {dropdownItem.name?.includes("LIVE") ? (
                    <div className="w-full">
                      {dropdownItem.name.replace(/LIVE/g, "")}{" "}
                      <span className="float-right font-bold text-red-600">
                        LIVE
                      </span>
                    </div>
                  ) : (
                    dropdownItem.name
                  )}
                </NavLink>
              </li>
            ))
          ) : (
            <li key={key}>
              <NavLink
                to={item.link || ""}
                className="inline-block w-full py-3 text-xs text-gray-400 uppercase transition duration-300 border-b hover:border-black hover:text-black"
              >
                {item.name}
              </NavLink>
            </li>
          )
        )}
      </ul>
    </nav>
  );
};

export default FooterNav;
